import React from 'react'
import MainNavigation from './MainNavigation'
import { NavContextProvider } from './useNavContext'
import { getMainNavigationMenu } from './getMainNavigationMenu'
import {
  JSONValue,
  prependHostName
} from '@toasttab/shared/src/utils/siteUtils'
import withNinetailedExperience from '@toasttab/shared/src/utils/Ninetailed/withNinetailedExperience'
import NT_NavController from '@toasttab/shared/src/components/Ninetailed/NT_NavController'
import { usePageContext } from '@toasttab/shared/src/hooks/usePageContext'
import { useHeaderContent } from '@toasttab/shared/src/utils/layoutUtils'
import { NavControllerProps, SiteRegionTypes } from './ContentfulNavigation.d'

const NavController = ({
  localizedEntries,
  packageName,
  siteId,
  siteMetadata
}: NavControllerProps) => {
  const { headerData, headerOverride, region } = usePageContext()

  const headerContent = useHeaderContent({
    headerData: headerData?.pageHeader,
    headerOverride,
    region
  })

  // Use Ninetailed if we have a valid nt_experience
  if (headerData?.nt_experiences || headerOverride?.nt_experiences) {
    // Which do we want to take priority here?
    const ntHeader = headerData?.nt_experiences ? headerData : headerOverride

    const props = {
      ...ntHeader,
      localizedEntries
    }
    return withNinetailedExperience(NT_NavController, { ...props }, true)
  }

  const siteRegion = region?.toLowerCase() as SiteRegionTypes

  const menus = headerContent?.navMenuItems
    ? [...headerContent.navMenuItems]
    : []

  //Prepend https://pos.toasttab.com for support.toasttab.com
  const navigationData =
    packageName === 'support'
      ? prependHostName(
          getMainNavigationMenu(menus, siteRegion) as unknown as JSONValue,
          siteMetadata.hostName
        )
      : getMainNavigationMenu(menus, siteRegion)

  const heapClasses = {
    login: `${siteRegion}_topnav_login`,
    mainNav:
      siteRegion === 'us' ? `topnav_entire_v` : `${siteRegion}_topnav_entire`,
    regionSwitcher: `${siteRegion}_topnav_region`,
    requestDemo: `${siteRegion}_topnav_demo`,
    restaurantSearch: `${siteRegion}_topnav_restaurants`
  }
  const navContext = {
    ...headerContent,
    heapClasses,
    localizedEntries,
    navigationData:
      typeof navigationData === 'string'
        ? JSON.parse(navigationData)
        : navigationData,
    siteId,
    siteRegion
  }

  return (
    <NavContextProvider value={navContext}>
      <MainNavigation />
    </NavContextProvider>
  )
}

export default NavController
